import React, { createContext, useContext } from 'react';
import { AdminResponse } from '../types/auth';

interface AuthContextType {
  currentAdmin: AdminResponse | null;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ currentAdmin: AdminResponse | null; children: React.ReactNode }> = ({
  currentAdmin,
  children
}) => {
  return (
    <AuthContext.Provider value={{ currentAdmin }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
